import React from 'react';

export const getProductName = (type) => {
  switch(type) {
    case 'jeju': return '제주 스냅';
    case 'main': return '본식 스냅';
    case 'simple': return '심플 스튜디오';
    case 'dme': return '드레스·메이크업';
    case 'dvd': return '본식DVD';
    case 'remind': return '리마인드웨딩';
    case 'family': return '가족사진';
    default: break;
  }
}

export const getMembershipName = (type) => {
  switch(type) {
    case 0: return '스페셜(베이직)';
    case 1: return '마스터(플러스)';
    case 2: return '마스터(퍼스트)';
    case 3: return '마스터(프리미엄)';
    case 4: return '스페셜';
    case 5: return '마스터';
    case 6: return '프리미엄';
    default: break;
  }
}

export const getMembershipNameByType = (type, membershipType) => {
  if (type !== "dme") {
    switch(membershipType) {
      case 0: return '스페셜(베이직)';
      case 1: return '마스터(플러스)';
      case 2: return '마스터(퍼스트)';
      case 3: return '마스터(프리미엄)';
      case 4: return '스페셜';
      case 5: return '마스터';
      case 6: return '프리미엄';
      default: break;
    }
  } else if (type === 'dme') {
    switch(membershipType) {
      case 0: return '스페셜';
      case 1: return '마스터';
      case 2: return '프리미엄';
      default: break;
    }
  }
}

export const getDmeMembershipName = (type) => {
  switch(type) {
    case 0: return '스페셜';
    case 1: return '마스터';
    case 2: return '프리미엄';
    default: break;
  }
}

export const getPayType = (type) => {
  switch(type) {
    case "card": return '카드';
    case "deposit": return '계좌이체';
    default: break;
  }
}

export const getColor = (type, membershipType) => {
  if (type !== "dme") {
    switch(membershipType) {
      case 0: return 'gray';
      case 1: return 'purple';
      case 2: return 'purple';
      case 3: return 'purple';
      case 4: return 'green';
      case 5: return 'purple';
      case 6: return 'gold';
      default: break;
    }
  } else if (type === "dme") {
    switch(membershipType) {
      case 0: return 'green';
      case 1: return 'purple';
      case 2: return 'gold';
      default: break;
    }
  }
}

export const getStatusName = (status)  => {
  switch (status) {
    case 0: return '예약 신청';
    case 1: return '담당자 지정 완료';
    case 2: return '업체 지정 완료';
    case 3: return '안심결제 요청';
    case 4: return '안심결제 완료';
    case 5: return '인보이스 발행';
    case 6: return '촬영 알림 발신';
    case 7: return '촬영 완료';
    case 8: return '원본 접수 완료';
    case 9: return '원본 셀렉 요청';
    case 10: return '보정 진행 중';
    case 11: return '최종 완료';
    case 12: return '정산 완료';
    case 80: return '요청기간 만료';
    case 90: return '컴플레인';
    case 99: return '취소';
    default: return '기타 (' + status + ')';
  }
}

export const getProxyStatusName = (status) => {
  switch(status) {
    case 0: return '답변 요청';
    case 1: return '답변 대기중';
    case 2: return '답변 완료';
    case 3: return '결제 링크 발송';
    case 4: return '결제 요청';
    case 5: return '결제 완료';
    case 6: return '안내 메시지 발송';
    case 10: return '촬영 완료';
    case 11: return '정산 완료';
    case 80: return '요청기간 만료';
    case 90: return '컴플레인';
    case 98: return '환불';
    case 99: return '취소';
    default: return '기타 (' + status + ')';
  }
}




// WEBPACK FOOTER //
// ./client/utils/type.js